import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userView: null,
  loading: false,
  error: null,
  loaded: false,
  showPopupToast: null,
  tzData:[],
  navigation:[],
  isAuthenticatedRequest: false,
  dateFormatString: null,
  dateTimeFormatString: null,
  timeZoneId: null,
  timeZoneTz: null,
  isWorkkardGridView: false,
  isActivityGridView: false,
  isFirstTimeLoggedInUser: false,
  isAuditUser: false,
  userSettingView: null,
  userTemplates: [],
  accessToOrgIds: [],
  combineAccessibleOrgs: [],
  organizationView: null,
  organizationLoading: false,
  organizationLoaded: false,
  organizationError: null,
};

const sessionContextOidcSlice = createSlice({
  name: "sessionContextOidc",
  initialState,
  reducers: {
    fetchSessionContextOidcRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchSessionContextOidcSuccess: (state, action) => {
      state.loading = false;
      state.error = null;
      state.loaded = true;
      state.userView = action.payload.userView || null;
      state.userTemplates = action.payload.userTemplates || [];
      state.tzData = action.payload.tzData || [];
      state.accessToOrgIds = action.payload.accessToOrgIds || [];
      state.isAuditUser = action.payload.isAuditUser ?? state.isAuditUser;
    },
    fetchSessionContextOidcError: (state, action) => {
      state.loading = false;
      state.error = action.payload || "Failed to fetch current user";
    },
    clearSessionContextOidc: (state) => {
      state.userView = null;
      state.loading = false;
      state.error = null;
      state.loaded = false;
      state.organizationView = null;
      state.organizationLoading = false;
      state.organizationLoaded = false;
      state.organizationError = null;
    },
    fetchOrganizationViewRequest: (state) => {
      state.organizationLoading = true;
      state.organizationLoaded = false;
      state.organizationError = null;
    },

    fetchOrganizationViewSuccess: (state, action) => {
      state.organizationView = action.payload || null;
      state.organizationLoading = false;
      state.organizationLoaded = true;
      state.organizationError = null;
    },

    fetchOrganizationViewError: (state, action) => {
      state.organizationLoading = false;
      state.organizationLoaded = false;
      state.organizationError =
        action.payload || "Failed to fetch organization";
    },
    updateOrganizationView: (state, action) => {
      state.organizationView = { ...state.organizationView,...action.payload }
    },
    updateUserView: (state, action) => {
      if (!state.userView || !action.payload) return;
      state.userView = { ...state.userView, ...action.payload };
    },
    // Silent re-fetch of the current user: leaves `loading` alone so open
    // panels do not flash a loader. Handled by sessionContextOidcSaga.
    refreshCurrentUserRequest: () => {},
  },
});

export const {
  fetchSessionContextOidcRequest,
  fetchSessionContextOidcSuccess,
  fetchSessionContextOidcError,
  clearSessionContextOidc,
  fetchOrganizationViewRequest,
  fetchOrganizationViewSuccess,
  fetchOrganizationViewError,
  updateOrganizationView,
  updateUserView,
  refreshCurrentUserRequest,
} =sessionContextOidcSlice.actions;

export default sessionContextOidcSlice.reducer;
